<div class="relances-container">
  <div class="relances-header">
    <div>
      <h1>Relances APRIL</h1>
      <p class="subtitle">
        Renvoi du mail «&nbsp;{{ subject || "DEMANDE D'INFORMATIONS + DEVIS ASSURANCE DE PRET APRIL" }}&nbsp;»
        &mdash; dimanche 11h, mercredi 16h, vendredi 18h pendant {{ weeks }} semaines
        ({{ maxSends }} envois par destinataire).
        La 1re relance part toujours le dimanche qui suit l'envoi du mail.
      </p>
      <p class="subtitle muted" *ngIf="syncing">
        <i class="pi pi-spin pi-spinner"></i>
        Recherche des nouveaux mails dans Gmail…
      </p>
      <p class="subtitle muted" *ngIf="activationAt">
        Campagne en route depuis le
        {{ activationAt | date: 'dd/MM/yyyy' }} a {{ activationAt | date: 'HH:mm' }}
        &mdash; seuls les mails envoyés après cette date sont relancés.
      </p>
    </div>

    <div class="header-actions">
      <button
        pButton
        type="button"
        [icon]="syncing ? 'pi pi-spin pi-spinner' : 'pi pi-inbox'"
        [label]="syncing ? 'Recherche en cours...' : 'Rechercher dans Gmail'"
        class="p-button-outlined"
        pTooltip="Le scan est déjà automatique à l'ouverture de la page. Ce bouton le relance."
        tooltipPosition="bottom"
        [disabled]="loading || syncing"
        (click)="sync()"
      ></button>
      <button
        pButton
        type="button"
        icon="pi pi-refresh"
        label="Actualiser"
        [disabled]="loading"
        (click)="refresh()"
      ></button>
    </div>
  </div>

  <div class="metrics-grid">
    <div class="metric-card metric-success">
      <span class="metric-label">En cours</span>
      <strong>{{ activeCount }}</strong>
    </div>
    <div class="metric-card metric-warning">
      <span class="metric-label">Stoppées</span>
      <strong>{{ stoppedCount }}</strong>
    </div>
    <div class="metric-card metric-info">
      <span class="metric-label">Terminées</span>
      <strong>{{ finishedCount }}</strong>
    </div>
    <div class="metric-card metric-danger">
      <span class="metric-label">En erreur</span>
      <strong>{{ failedCount }}</strong>
    </div>
  </div>

  <div class="banner banner-error" *ngIf="error">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ error }}</span>
    <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-sm"
            (click)="error = null"></button>
  </div>

  <div class="banner banner-info" *ngIf="info">
    <i class="pi pi-info-circle"></i>
    <span>{{ info }}</span>
    <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-sm"
            (click)="info = null"></button>
  </div>

  <div class="filters-bar">
    <span class="p-input-icon-left search-field">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        [(ngModel)]="searchTerm"
        placeholder="Recherche par email ou nom"
        (keyup.enter)="applyFilters()"
      />
    </span>

    <p-dropdown
      [options]="statusOptions"
      [(ngModel)]="selectedStatus"
      optionLabel="label"
      optionValue="value"
      placeholder="Statut"
      appendTo="body"
      [scrollHeight]="'320px'"
      (onChange)="applyFilters()"
    ></p-dropdown>
  </div>

  <p-table
    [value]="relances"
    [loading]="loading"
    [paginator]="relances.length > 25"
    [rows]="25"
    styleClass="p-datatable-sm relances-table"
    responsiveLayout="scroll"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Destinataire</th>
        <th>Statut</th>
        <th class="col-center">Envois</th>
        <th>Dernier envoi</th>
        <th>Prochain envoi</th>
        <th>Fin de campagne</th>
        <th class="col-center">Action</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-relance>
      <tr [class.row-stopped]="relance.status === 'stopped'">
        <td>
          <div class="recipient">
            <strong>{{ relance.recipient_name || relance.recipient_email }}</strong>
            <small *ngIf="relance.recipient_name">{{ relance.recipient_email }}</small>
          </div>
        </td>

        <td>
          <p-tag
            [value]="statusLabel(relance.status)"
            [severity]="statusSeverity(relance.status)"
          ></p-tag>
          <small class="error-hint" *ngIf="relance.last_error" [pTooltip]="relance.last_error"
                 tooltipPosition="top">
            <i class="pi pi-exclamation-circle"></i> voir l'erreur
          </small>
        </td>

        <td class="col-center">
          <span class="sends-badge">{{ relance.sends_done }} / {{ relance.max_sends }}</span>
        </td>

        <td>
          <span *ngIf="relance.last_sent_at; else neverSent">
            {{ relance.last_sent_at | date: 'dd/MM/yyyy HH:mm' }}
          </span>
          <ng-template #neverSent><span class="muted">&mdash;</span></ng-template>
        </td>

        <td>
          <span *ngIf="relance.next_send_at; else noNextSend">
            {{ relance.next_send_at | date: 'EEEE dd/MM' }}
            <small class="muted">{{ relance.next_send_at | date: 'HH:mm' }}</small>
          </span>
          <ng-template #noNextSend><span class="muted">&mdash;</span></ng-template>
        </td>

        <td>
          <span>{{ relance.campaign_ends_at | date: 'dd/MM/yyyy' }}</span>
          <small class="muted days-left" *ngIf="relance.status === 'active'">
            {{ daysLeft(relance) }} j restants
          </small>
        </td>

        <td class="col-center">
          <button
            *ngIf="relance.status === 'active'"
            pButton
            type="button"
            icon="pi pi-ban"
            label="Stop"
            class="p-button-danger p-button-sm p-button-outlined"
            pTooltip="Arrete les relances de ce destinataire uniquement"
            tooltipPosition="left"
            [disabled]="isPending(relance)"
            (click)="stop(relance)"
          ></button>

          <button
            *ngIf="relance.status === 'stopped' || relance.status === 'failed'"
            pButton
            type="button"
            icon="pi pi-play"
            label="Reprendre"
            class="p-button-success p-button-sm p-button-outlined"
            [disabled]="isPending(relance)"
            (click)="resume(relance)"
          ></button>

          <span class="muted" *ngIf="relance.status === 'finished'">Terminée</span>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="empty-row">
          Aucune relance. Clique sur «&nbsp;Rechercher dans Gmail&nbsp;» pour inscrire
          les mails déjà envoyés.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
